/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Package, Share2, ShoppingBag, Store, Calendar, User } from 'lucide-react';
import { useOrders } from '../../../contexts/OrderContext';
import { URLS } from '../../../constant/constant';

const navItems = [
  { to: '/', icon: ShoppingBag, label: 'Orders', pageName: 'orders' },
  { to: '/product/pricing', icon: Package, label: 'Products', pageName: 'pricing' },
  { to: '/events', icon: Calendar, label: 'Dashboard', pageName: 'events' },
  { to: '/vendor/profile', icon: User, label: 'Profile', pageName: 'profile' },
];

export default function BottomNav({ page = 'dashboard' }) {
  const { orderCount } = useOrders();
  const { user } = useUser();

  // Check if user is an event vendor
  const isEventVendor =
    user?.attributeValues?.find((attr) => attr.name === 'isEventVendor')?.value === 'true';

  // Filter nav items based on user type
  const filteredNavItems = navItems.filter((item) => {
    // Show events link only if user is an event vendor
    if (item.pageName === 'events') {
      return isEventVendor;
    }
    return true;
  });

  // A reusable function to render each nav item
  const renderNavItem = (item) => {
    const isActive = page === item.pageName;
    return (
      <Tooltip key={item.label}>
        <TooltipTrigger asChild>
          <Link
            to={item.to}
            className={`flex flex-1 flex-col items-center justify-center p-2 transition-all duration-200 ${
              isActive ? 'text-orange-600 scale-110' : 'text-gray-500 hover:text-orange-500'
            }`}
          >
            <div className="relative">
              <item.icon className="size-5" />
              {item.pageName === 'orders' && orderCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[8px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                  {orderCount > 9 ? '9+' : orderCount}
                </span>
              )}
            </div>
            <span className={`text-[10px] mt-1 ${isActive ? 'font-bold' : ''}`}>{item.label}</span>
          </Link>
        </TooltipTrigger>
        <TooltipContent side="top">
          <p>{item.label}</p>
        </TooltipContent>
      </Tooltip>
    );
  };

  return (
    // This wrapper hides the component on screens 'md' and larger
    <nav className="md:hidden">
      <TooltipProvider delayDuration={100}>
        <div className="w-full fixed bottom-0 left-0 right-0 h-16 flex items-center justify-around bg-white border-t-2 border-gray-200 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-50">
          {filteredNavItems.map((item) => renderNavItem(item))}
        </div>
      </TooltipProvider>
    </nav>
  );
}
